import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useModelQuery from '../hooks/useModelQuery';
import ModelForm from '../components/ModelForm';
import getFormTitle from '#/common/utils/getFormTitle';
import useNotFoundGuard from '#/common/hooks/useNotFoundGuard';
import RecordNotFound from '#/app/pages/errors/RecordNotFound';

export interface ModelParams {
  readonly id?: string;
}

const ModelPage: React.FC = () => {
  const { id } = useParams() as ModelParams;
  const modelQuery = useModelQuery(id);
  const model = modelQuery.data?.getModel?.data;
  const isNotFound = useNotFoundGuard({ loading: modelQuery.loading, id, entity: model });

  // Use a ref to store the initial updatedAt value to prevent form remount
  // on background refetches (cache-and-network).
  const formKeyRef = useRef<string | null>(null);
  if (model && !formKeyRef.current) {
    formKeyRef.current = model.updatedAt ?? model.id ?? null;
  }

  const modelName = model?.name;
  const title = getFormTitle(id, modelName, 'Model');

  if (isNotFound) {
    return (
      <SubPage title={title} showGoBackButton type="form" isLoading={false}>
        <RecordNotFound backUrl="/assets/models" />
      </SubPage>
    );
  }

  return (
    <SubPage title={title} isLoading={modelQuery.loading} showGoBackButton type="form">
      {<ModelForm key={`model-${id}-${formKeyRef.current}`} title={title} model={model || {}} />}
    </SubPage>
  );
};

export default React.memo(ModelPage);
